import { Button, Form, Input, Modal, Select, InputNumber, message } from "antd";
import { Col, Row } from "react-bootstrap";
import { API } from "../../../../config/Api";
import { POST } from "../../../../utils/apiRequest";
import { useEffect, useState } from "react";

const TransactionSettle = ({
  isModalOpen,
  handleCancel,
  data,
  isLoading,
  due,
  reload
}: any) => {
  const [form] = Form.useForm();
  const [payable, setPayable] = useState<any>()
  const [dueList, setDueList] = useState<any>([]);
  const [selectedDueItem, setSelectedDueItem] = useState<any>(null);


  // When the modal opens, reset the form values
  useEffect(() => {
    if (isModalOpen) {
      form.resetFields();
      getUserDues();
    }
  }, [isModalOpen]);


  const getUserDues = async () => {
    try {
      const obj = { user_id: data?.user?.id };
      const response: any = await POST(API.LIST_USER_DUES, obj);
      if (response?.status) {
        setDueList(response?.data || []);
      } else {
        setDueList([]);
        message.error(response?.message || "Failed to fetch dues");
      }
    } catch (err) {
      console.error("Error fetching dues:", err);
      message.error("An error occurred while fetching dues.");
    }
  };



  // Extract numeric value from the selected due option
  const handleDueChange = (value: number, option: any) => {
    const selectedItem = dueList.find((dueItem: any) => dueItem.outstanding === value);
    setSelectedDueItem(selectedItem || null);
    form.setFieldsValue({ paid_mount: value });
    setPayable(value);
  };


  // Handle form submission
  const onFinish = async (val: any) => {
    if (!selectedDueItem) {
      message.error("Please select a due before submitting.");
      return;
    }
  
    try {
      const obj = {
        order_id: selectedDueItem?.id,
        paid_mount: val?.paid_mount.toString(),
        payment_method: val?.payment_method,
        comment: val?.comment,
        type: selectedDueItem?.user_type,
        by: `${data?.user?.first_name} ${data?.user?.last_name}`
      };
  
      const response: any = await POST(API.PAY_DUES, obj);
      if (response?.status) {
        message.success(response?.message || "Successfully settled the amount");
        handleCancel();
        reload();
      } else {
        message.error(response?.message || "Failed to settle the amount");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };
  

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      centered
      closeIcon={false}
    >
      <h5 className="user-heading">
        Settle Due - {data?.user?.first_name} {data?.user?.last_name} ({data?.user?.admisson_id})
      </h5>

      <Form form={form} layout="vertical" onFinish={onFinish} hideRequiredMark>
        <Form.Item>
          <Button disabled className="text-danger">
            Total Due Amount : ₹{due}
          </Button>
        </Form.Item>

        {/* Choose Due Amount */}
        <Form.Item
          name="due"
          label="Choose Due"
          rules={[{ required: true, message: "Please select a due amount" }]}
        >
          <Select allowClear showSearch onChange={handleDueChange}>
            {dueList?.map((dueItem: any) => (
              <Select.Option value={dueItem.outstanding} key={dueItem.id}>
                ₹{dueItem.outstanding} on {dueItem.subscription?.name?.trim()}
              </Select.Option>
            ))}
          </Select>



        </Form.Item>

        {/* Amount to Pay */}
        <Form.Item
          label="Amount to Pay"
          name="paid_mount"
          rules={[
            { required: true, message: "Please enter a valid amount" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (value > payable) {
                  return Promise.reject(new Error(`Amount cannot exceed ₹${payable}`));
                }
                if (value < 1) {
                  return Promise.reject(new Error("Amount must be at least ₹1"));
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <InputNumber
            min={1}
            max={due}
            style={{ width: "100%" }}
            placeholder="Enter amount"
          />
        </Form.Item>

        {/* Comments */}
        <Form.Item label="Comments" name="comment">
          <Input placeholder="Settled..." />
        </Form.Item>

        {/* Payment Method */}
        <Form.Item
          name="payment_method"
          label="Payment Method"
          rules={[{ required: true, message: "Choose a Payment Method" }]}
        >
          <Select placeholder="Choose Payment Method">
            {["BANK", "UPI", "CARD", "CASH"].map((method, idx) => (
              <Select.Option value={method} key={idx}>
                {method}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Buttons */}
        <Row>
          <Col md={5}></Col>
          <Col md={7}>
            <div className="d-flex gap-2">
              <Button block onClick={handleCancel}>
                Close
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={isLoading}
              >
                Settle
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default TransactionSettle;